import React from 'react';
import Nav from './Utilities/Nav';

export default function Issues() {
  return (
    <>
      <h1>Issues</h1>
      <Nav />
    </>
  );
}
